import type { AxiosInstance } from "axios";

export type AnalyticsEmbedUrlResponse = {
  url: string;
  lightThemeArn?: string;
  darkThemeArn?: string;
};

export class AnalyticsService {
  constructor(private readonly axios: AxiosInstance) {}

  async getAnalyticsEmbedInfo(): Promise<AnalyticsEmbedUrlResponse> {
    const response = await this.axios.get<AnalyticsEmbedUrlResponse>(
      "/analytics/embed-info",
    );

    return response.data;
  }

  async getBrandPerformanceEmbedInfo(): Promise<AnalyticsEmbedUrlResponse> {
    const response = await this.axios.get<AnalyticsEmbedUrlResponse>(
      "/brand-performance/embed-info",
    );

    return response.data;
  }
}
